<template>
  <div
    class="container"
    :style="{ width }"
  >
    <slot v-if="isLoaded">
      No content provided
    </slot>
    <div
      v-for="index in amount"
      v-else
      :key="index"
      class="placeholder"
      :style="{ height, width }"
    >
      <LoadingSkeletonBase
        class="loader"
        :speed="1"
        preserve-aspect-ratio="none"
        :svg-style="{ width, height: '100%' }"
      >
        <rect
          x="0"
          y="0"
          rx="5"
          ry="5"
          class="menu-text"
        />
      </LoadingSkeletonBase>
    </div>
  </div>
</template>

<script>
import LoadingSkeletonBase from './base/LoadingSkeletonBase.vue';

export default {
  name: 'LoadingSkeleton',
  components: { LoadingSkeletonBase },
  props: {
    amount: {
      type: Number,
      default: 1,
    },
    height: {
      type: String,
      default: '25px',
    },
    width: {
      type: String,
      default: '100%',
    },
    isLoaded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .container {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr;

    .placeholder {
      line-height: 0;
    }
  }

  svg {
    rect.menu-text {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }

</style>
